import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 13.5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-5.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M10.42 12.61a2.1 2.1 0 1 1 2.97 2.97L7.95 21 4 22l.99-3.95 5.43-5.44Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "FileEdit";
const FileEdit = memo(themed(Icon));
export {
  FileEdit
};
//# sourceMappingURL=file-edit.js.map
